"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  num: "01",
  title: "Validate",
  desc: "Theory is a starting point, not a destination. We pressure-test core assumptions against market realities to confirm viable demand before a single line of code is written."
}, {
  num: "02",
  title: "Execute",
  desc: "We are operators, not advisors. Our team embeds to build high-fidelity products and brands, moving with the speed and precision required for early-stage success."
}, {
  num: "03",
  title: "Scale",
  desc: "Growth is systematized. We implement the operational frameworks and strategic clarity needed to transition from a founder-led project to an institutional-grade venture."
}];
export default function TheDeliveryProcess() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="114472" id="the-method" className="dark bg-card py-24 md:py-32 px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`mb-16 md:mb-24 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-medium text-foreground tracking-tight text-center font-default">
            The Method
          </h2>
        </div>

        <div ref={gridRef} className={`flex flex-col md:flex-row items-stretch transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {steps.map((step, i) => {
          const item = <div key={`item-${step.num}`} data-index={i} className={`flex-1 flex flex-col ${i === 0 ? "md:pr-8 pb-16 md:pb-0" : i === 1 ? "md:px-8 py-16 md:py-0" : "md:pl-8 pt-16 md:pt-0"}`}>
                <span className="text-7xl md:text-8xl font-medium text-primary/10 tracking-tighter leading-none mb-6 block font-default">
                  {step.num}
                </span>
                <h3 className="text-2xl md:text-3xl font-medium text-foreground mb-4 tracking-tight font-default">
                  {step.title}
                </h3>
                <p className="text-[17px] leading-[1.6] text-muted-foreground font-default max-w-sm">
                  {step.desc}
                </p>
              </div>;
          if (i === steps.length - 1) {
            return item;
          }
          return [item, <Separator key={`sep-v-${step.num}`} orientation="vertical" className="hidden md:block bg-border/40" />, <Separator key={`sep-h-${step.num}`} orientation="horizontal" className="md:hidden bg-border/40" />];
        })}
        </div>
      </div>
    </section>;
}